export const INCIDENT_API = (communityId: string) => `v1/community/${communityId}/incident`;
export const BOM_DASHBOARD_API = (communityId: string) => `v1/community/${communityId}/bom-dashboard`;
